import axios from "@/util/request.js";

export const departments = (params) => {
  return axios.get("/api/platform/organizations/departments", { params });
};

export const getUserHasCompany = () => {
  return axios.post("/api/platform/authright/getUserHasCompany");
};

export const login = (data) => {
  return axios.post("/api/platform/auth/login", data);
};
// 取用户token
export const getUToken = (data) => {
  return axios.post("/api/appsheets/sheetapi/getUToken", data);
};
// 获取列表数据
export const online = (params) => {
  return axios.get("/api/platform/forms/online", { params });
};

// 关联记录
export const relationOptions = (data) => {
  return axios.post("/api/platform/forms/relationOptions", data);
};

// 获取详情数据
export const detailOnline = (data) => {
  return axios.post("/api/platform/forms/detailOnline", data);
};


// 更新详情数据
export const updateOnline = (data) => {
  return axios.post("/api/platform/forms/updateOnline", data);
};

// 获取子表数据
export const children = (params) => {
  return axios.get("/api/platform/forms/children", { params });
};

export const relationFieldButtonExc = (data) => {
  return axios.post("/api/platform/forms/relationFieldButtonExc", data);
};

// 删除数据
export const delOnline = (data) => {
  return axios.post("/api/platform/forms/delOnline", data);
};


export const buttons = (data) => {
  return axios.post("/api/platform/forms/buttons", data);
};


export const getFormList = (data) => {
  return axios.post("/api/appsheets/sheetapi/getFormList", data);
};

export const execButton = (data) => {
  return axios.post("/api/platform/configs/execButton", data);
};

export const postOnline = (data) => {
  return axios.post("/api/platform/forms/online", data);
};

// 修改密码
export const changePwd = (data) => {
  return axios.post("/api/platform/authright/changePwd", data);
};

// 获取关联记录
export const relationRows = (data) => {
  return axios.post("/api/platform/forms/relationRows", data);
};

export const getQueryDataByFilterDefault = (data) => {
  return axios.post("/api/platform/forms/getQueryDataByFilterDefault", data);
};


export const getOtherSystemGetLoginToMeUrl = (data) => {
  return axios.post("/api/general/sso/getOtherSystemGetLoginToMeUrl", data);
};

export const structure = (form_head_uuid, params) => {
  return axios.get(`/api/platform/forms/structure/${form_head_uuid}`, params);
};


//根据SHEET API创建数据时，返回的"表单行数据ID"，进行获取审批数据。
export const getFormRowApproveList = (data) => {
  return axios.post(`/api/appsheets/sheetapi/getFormRowApproveList`, data);
};

// 审批流程 - 撤回审批
export const setApproveClose = (data) => {
  return axios.post(`/api/appsheets/sheetapi/setApproveClose`, data);
};
//微信native支付
export const weiXinNativePay = (data) => {
  return axios.post(`/api/general/otherPay/weiXinNativePay`, data);
};

// 获取订单状态
export const getOrderStatus = (data) => {
  return axios.post(`/api/general/otherPay/getOrderStatus`, data);
};


// 获取代办列表
export const todolist = (data) => {
  return axios.post(`/api/platform/todolist/index`, data);
};


export const todolistShow = (data) => {
  return axios.post(`/api/platform/todolist/show`, data);
};

export const checktodo = (data) => {
  return axios.post(`/api/platform/todolist/checktodo`, data);
};

// 批量审批
export const approveAllowApprovalBatchAction = (data) => {
  return axios.post(`/api/platform/todolist/approveAllowApprovalBatchAction`, data);
};


export const getQueueText = (data) => {
  return axios.post(`/api/general/getQueueText`, data);
};

// api/general/getQueueText


// WEBPACK FOOTER //
// ./src/api/platform.js